import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import Header from "./components/Header";
import Cards from "./components/Cards";
import ExamType from "./components/ExamType";
import SectionDivider from "./common/SectionDivider";
import ShareCard from "./common/ShareCard";
import SocialLinks from "./components/SocialLinks";
import BalVibhag from "./screens/BalVibhag/BalVibhag";
import NavUjaniye from "./screens/BalVibhag/NavUjaniye";
import NavUjaniyeMaterial from "./screens/BalVibhag/NavUjaniyeMaterial";
import GujaratiKakko from "./screens/BalVibhag/GujaratiKakko";
import EnglishAbcd from "./screens/BalVibhag/AbcdData";
import HindiKakko from "./screens/BalVibhag/HindiKakkoData";
import EkadaData from "./screens/BalVibhag/EkadaData";

import Banner from "./components/Banner";
import Bcont from "./components/Bcont";
import EnglishAkdaData from "./screens/BalVibhag/EnglishAkdaData";
import HindiAkdaData from "./screens/BalVibhag/HindiAkdaData";

import Ghadiya from "./screens/BalVibhag/Ghadiya";
import Ghadia1to30 from "./screens/BalVibhag/Ghadia1to30";
import PrathmikVibhag from "./screens/PrathmikVibhag/PrathmikVibhag";
import Subjects from "./screens/PrathmikVibhag/Subjects";
import UpperPrimary from "./screens/UchchPrathmikVibhag/UchchPrathmikVibhag";
import UpperPrimarySubjects from "./screens/UchchPrathmikVibhag/Subjects";
import MadhyamikVibhag from "./screens/MadhyamikVibhag/MadhyamikVibhag";
import MadhyamikSubjects from "./screens/MadhyamikVibhag/Subjects";
import Uchchmadhyamikvibhag from "./screens/Uchchmadhyamikvibhag/Uchchmadhyamikvibhag";

import UMadhyamikTab from "./screens/Uchchmadhyamikvibhag/UMadhyamik";
import JawaharNavodayaClass5 from "./screens/Jawahar_Navodaya_Class_5/Jawahar_Navodaya_Class_5";
import NMMS from "./screens/NMMS/NMMS";



function RedirectGhadiya() {
  const { num } = useParams();
  return <Navigate to={`/bal-vibhag/ghadiya/${num}`} replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Header />
      <main>
        <Routes>

          {/* HOME PAGE = CARDS + EXAM TYPES */}
          <Route
            path="/"
            element={
              <>
                <Banner />
                <Bcont />
                <SectionDivider title="મુખ્ય વિભાગો" />
                <Cards />
                <SectionDivider title="મહત્વની પરીક્ષાઓનું મટીરીયલ" />
                <ExamType />
                <SectionDivider title="અમને ફોલોઓ કરો" />
                <ShareCard />
                <SectionDivider title="અમને ફોલોઓ કરો" />
                <SocialLinks />
              </>
            }
          />

          {/* BAL VIBHAG SCREEN */}
          <Route
            path="/bal-vibhag"
            element={
              <>
                <BalVibhag />
                <NavUjaniye />
              </>
            }
          />

          <Route path="/bal-vibhag/gujarati-kakko" element={<GujaratiKakko />} />
          <Route path="/bal-vibhag/english-abcd" element={<EnglishAbcd />} />
          <Route path="/bal-vibhag/hindi-kakko" element={<HindiKakko />} />
          <Route path="/bal-vibhag/gujarati-ekada" element={<EkadaData />} />
          <Route path="/bal-vibhag/english-ekada" element={<EnglishAkdaData />} />
          <Route path="/bal-vibhag/hindi-ekada" element={<HindiAkdaData />} />
          <Route path="/bal-vibhag/ghadiya" element={<Ghadia1to30 />} />
          <Route path="/bal-vibhag/ghadiya/:num" element={<Ghadiya />} />

          {/* NAVU JANIYE SCREEN */}
          <Route
            path="/navu_janiye"
            element={<NavUjaniye />}
          />

          <Route path="/navu_janiye/:id" element={<NavUjaniyeMaterial />} />

          {/* GUJARATI KAKKO SCREEN */}

          <Route
            path="/gujarati-kakko"
            element={<Navigate to="/bal-vibhag/gujarati-kakko" replace />}
          />
          <Route path="/english-abcd" element={<Navigate to="/bal-vibhag/english-abcd" replace />} />
          <Route path="/hindi-kakko" element={<Navigate to="/bal-vibhag/hindi-kakko" replace />} />
          <Route path="/gujarati-ekada" element={<Navigate to="/bal-vibhag/gujarati-ekada" replace />} />
          <Route path="/english-ekada" element={<Navigate to="/bal-vibhag/english-ekada" replace />} />
          <Route path="/hindi-ekada" element={<Navigate to="/bal-vibhag/hindi-ekada" replace />} />
          <Route path="/ghadiya" element={<Navigate to="/bal-vibhag/ghadiya" replace />} />
          <Route path="/ghadiya/:num" element={<RedirectGhadiya />} />


          <Route path="/prathmik-vibhag" element={<PrathmikVibhag />} />

          <Route path="/prathmik-vibhag/subjects" element={<Subjects />} />
          <Route path="/subjects" element={<Navigate to="/prathmik-vibhag/subjects" replace />} />
         
          <Route path="/upper-primary" element={<UpperPrimary />} />
          <Route path="/upper-primary/subjects" element={<UpperPrimarySubjects />} />
          <Route path="/upper-primary-subjects" element={<Navigate to="/upper-primary/subjects" replace />} />
          <Route path="/madhyamik-vibhag" element={<MadhyamikVibhag />} />
          <Route path="/madhyamik-vibhag/subjects" element={<MadhyamikSubjects />} />
          <Route path="/madhyamik-subjects" element={<Navigate to="/madhyamik-vibhag/subjects" replace />} />
          <Route path="/higher-secondary" element={<Uchchmadhyamikvibhag />} />

          <Route path="/umadhyamik/:id" element={<UMadhyamikTab />} />

          <Route path="/navodaya-vibhag/jawahar-navodaya-class-5" element={<JawaharNavodayaClass5 />} />
          <Route path="/navodaya-vibhag/jawahar-navodaya-class-5/subjects" element={<Subjects />} />

          <Route
            path="/navodaya-vibhag/gnansetu-cet-class-5"
            element={<JawaharNavodayaClass5 variant="cet" />}
          />
          <Route
            path="/navodaya-vibhag/gnansetu-cet-class-5/subjects"
            element={<Subjects />}
          />

          <Route
            path="/navodaya-vibhag/gnansadhna-class-8"
            element={<JawaharNavodayaClass5 variant="gnansetu8" />}
          />
          <Route
            path="/navodaya-vibhag/gnansadhna-class-8/subjects"
            element={<Subjects />}
          />

          <Route
            path="/jawahar-navodaya-class-5"
            element={<Navigate to="/navodaya-vibhag/jawahar-navodaya-class-5" replace />}
          />
          <Route
            path="/jawahar-navodaya-class-5/subjects"
            element={<Navigate to="/navodaya-vibhag/jawahar-navodaya-class-5/subjects" replace />}
          />

          <Route path="/nmms" element={<NMMS />} />
          <Route path="/nmms/subjects" element={<Subjects />} />

          <Route path="*" element={<Navigate to="/" replace />} />

        </Routes>
      </main>
    </BrowserRouter>
  );
}

export default App;
